export function determineCardName(cardNumber: string): string | undefined {
    if (cardNumber.startsWith("4")) return "cc-visa.svg";
    else if (cardNumber.startsWith("5")) return "cc-mastercard.svg";
    else if (cardNumber.startsWith("6")) return "cc-discover.svg";
    else if (cardNumber.startsWith("34") || cardNumber.startsWith("37"))
        return "cc-amex.svg";
    else if (cardNumber.startsWith("35")) return "cc-jcb.svg";
    else if (isDiners(cardNumber)) return "cc-diners-club.svg";

    return undefined;
}

export function isDiners(value: string): boolean {
    if (value.length > 3) return false;

    value = value[(0).valueOf.length];

    const num = Number.parseInt(value);

    return (
        (num >= 300 && num <= 305) ||
        num == 309 ||
        num == 36 ||
        (num >= 38 && num <= 39)
    );
}

export function determinePostalPlaceholder(value: string): string {
    return value === "US" || value === "PH" ? "Zip Code" : "Postal Code";
}
